/**
 * RaceTrace's help (plan item 11): a separate site at /help/ (help/ in the repo, Docusaurus),
 * served beside the app by the same Vercel project. Links to it load the page in full (it is not a
 * route of this app); /usermanual and /user-manual redirect to it.
 */
export const HELP_URL = "/help/";

/** A help page's address: "live/" → "/help/live/". */
export function helpUrl(page = ""): string {
  return `${HELP_URL}${page.replace(/^\/+/, "")}`;
}

/**
 * A "?" that opens the help in a new tab, so the race stays put: the top bar's (the help's front
 * page), and each race and Live tab's (its own page, `topic` naming it).
 */
export function HelpButton({
  page = "",
  topic,
  onDark = false,
  large = false,
  className = "",
}: {
  page?: string;
  /** What the page explains ("Position Trace"): said in the tooltip. */
  topic?: string;
  /** On a race or Live screen (always dark): its own greys. */
  onDark?: boolean;
  /** A phone header's 44 px target, as its other buttons. */
  large?: boolean;
  className?: string;
}) {
  return (
    <a
      href={helpUrl(page)}
      target="_blank"
      rel="noopener"
      title={
        topic
          ? `Help: how ${topic} works (opens in a new tab)`
          : "Help: how RaceTrace's pages and numbers work (opens in a new tab)"
      }
      aria-label={topic ? `Help on ${topic}` : "Help"}
      data-touch-44
      className={`relative flex ${large ? "h-11 w-11" : "h-8 w-8 before:absolute before:-inset-1.5 before:content-['']"} items-center justify-center rounded-md ${onDark ? "text-[#9a9ab4] hover:bg-white/10 hover:text-[#e0e0e8]" : "text-gray-500 hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-100"} ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        className="h-5 w-5"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <circle cx="12" cy="12" r="9.5" />
        <path d="M9.6 9.2a2.5 2.5 0 0 1 4.85.85c0 1.65-2.45 2.2-2.45 3.7" />
        <circle cx="12" cy="17" r="0.6" fill="currentColor" />
      </svg>
    </a>
  );
}
